var _rect, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconBath = function SvgIconBath(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 22,
    width: 24,
    height: 13.44,
    rx: 2,
    transform: "rotate(180 28 22)",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.12 15.28a3.84 3.84 0 0 1-3.84 3.84H7.656a.776.776 0 0 1-.776-.776v-6.128c0-.428.348-.776.776-.776H21.28a3.84 3.84 0 0 1 3.84 3.84Z",
    stroke: "#1D1D1D",
    strokeWidth: 1.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.3,
    cy: 15.1,
    transform: "rotate(180 11.3 15.1)",
    fill: "#1D1D1D",
    r: 0.9
  })));
};
export { SvgIconBath as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMjgiIHk9IjIyIiB3aWR0aD0iMjQiIGhlaWdodD0iMTMuNDQiIHJ4PSIyIiB0cmFuc2Zvcm09InJvdGF0ZSgxODAgMjggMjIpIiBzdHJva2U9IiMxRDFEMUQiIHN0cm9rZS13aWR0aD0iMS44Ii8+CjxwYXRoIGQ9Ik0yNS4xMjAxIDE1LjI4QzI1LjEyMDEgMTcuNDAwOCAyMy40MDA5IDE5LjEyIDIxLjI4MDEgMTkuMTJMNy42NTYyOSAxOS4xMkM3LjIyNzYyIDE5LjEyIDYuODgwMTIgMTguNzcyNSA2Ljg4MDEyIDE4LjM0MzhMNi44ODAxMiAxMi4yMTYyQzYuODgwMTIgMTEuNzg3NSA3LjIyNzYyIDExLjQ0IDcuNjU2MjkgMTEuNDRMMjEuMjgwMSAxMS40NEMyMy40MDA5IDExLjQ0IDI1LjEyMDEgMTMuMTU5MiAyNS4xMjAxIDE1LjI4VjE1LjI4WiIgc3Ryb2tlPSIjMUQxRDFEIiBzdHJva2Utd2lkdGg9IjEuOCIvPgo8ZWxsaXBzZSBjeD0iMTEuMzAwMiIgY3k9IjE1LjEiIHJ4PSIwLjkiIHJ5PSIwLjkiIHRyYW5zZm9ybT0icm90YXRlKDE4MCAxMS4zMDAyIDE1LjEpIiBmaWxsPSIjMUQxRDFEIi8+Cjwvc3ZnPgo=";